import axios from "axios";
import StorageUtil from '@/utils/storageUtil'

export default {
    header() {
        const headers = {
            Authorization: StorageUtil.readUser().token,
            deviceType: "mb",
            pageType: "trade",
            lang: JSON.parse(process.env.VUE_APP_LANG)[StorageUtil.readLang()]
        };
        return headers;
    },
    isAjax() {
        const headers = {
            isAjax: "true",
        };
        return headers;
    },
    Language() {
        const headers = {
            lang: JSON.parse(process.env.VUE_APP_LANG)[StorageUtil.readLang()]
        };
        return headers;
    },
    /*极验*/
    gt() {
        return axios.get(process.env.VUE_APP_API_URL + `/gt/register`, {headers: this.Language()})
    },
    /*验证码*/
    send(data, head) {
        return axios.post(process.env.VUE_APP_API_URL + `/minsms/send`, data, {headers: head})
    },
    /*轮播*/
    queryForApp(data) {
        return axios.post(process.env.VUE_APP_MIS + `/public/advertisingH5/queryForApp`, data, {headers: this.Language()})
    },
    /*验证手机号码是否注册过*/
    checkCustomerByMobileNo(data) {
        return axios.post(process.env.VUE_APP_API_URL + `/minaccount/checkCustomerByMobileNo`, data, {headers: this.Language()})
    },
    /*注册账户*/
    createAccount(data) {
        return axios.post(process.env.VUE_APP_API_URL + `/minaccount/create`, data, {headers: this.Language()})
    },
    /*根据token获取用户信息*/
    getCacheCustomerByToken(data) {
        return axios.get(process.env.VUE_APP_API_URL + `/account/getCacheCustomerByToken`, {
            headers: {
                "Authorization": data,
                lang: JSON.parse(process.env.VUE_APP_LANG)[StorageUtil.readLang()]
            }
        })
    },
    /*登录*/
    login(data) {
        return axios.post(process.env.VUE_APP_API_URL + `/account/login`, data, {headers: this.Language()})
    },
    /*账号切换*/
    transCustomerNumber(data) {
        return axios.post(process.env.VUE_APP_API_URL + `/account/transCustomerNumberForH5`, data, {headers: this.header()})
    },
    /*获取产品*/
    product(data) {
        return axios.get(process.env.VUE_APP_M + `/news/product?` + data)
    },
    /*获取资讯*/
    getArticleAllList(data) {
        return axios.get(process.env.VUE_APP_M + `/v1/api/article/getArticleAllList?` + data, {headers: this.isAjax()})
    },
    /*资讯详情*/
    detail(id, lang) {
        return axios.get(process.env.VUE_APP_M + `/v1/api/article/detail/` + id + `?lang=` + lang, {headers: this.isAjax()})
    },
    /*获取国家列表*/
    getCountryList() {
        return axios.post(process.env.VUE_APP_API_URL + `/account/getCountryList`, {headers: this.header()})
    },
    /*文件状态列表*/
    getFileStatus(data) {
        return axios.get(process.env.VUE_APP_API_URL + `/upload/getFileStatus?customerNumber=` + data, {headers: this.header()})
    },
    /*用户提现银行列表*/
    getCustomerBankList() {
        return axios.get(process.env.VUE_APP_API_URL + `/person/getCustomerBankList`, {headers: this.header()})
    },
    /*获取可用的支付方式列表*/
    getPaySwitchSeqList(data) {
        return axios.get(process.env.VUE_APP_API_URL + `/minfund/getPaySwitchSeqList?gts2CustomerId=` + data, {headers: this.header()})
    },
    /*获取支付方式支持的银行列表*/
    getBankList(data) {
        return axios.get(process.env.VUE_APP_API_URL + `/minfund/getBankList?paySwitchSeqId=` + data, {headers: this.header()})
    },
    /*获取最低存款金额*/
    getMinDepositAmount() {
        return axios.get(process.env.VUE_APP_API_URL + `/minfund/getMinDepositAmount?platform=GTS2`, {headers: this.header()})
    },
    /*点卡手续费*/
    getIviCardFee(data) {
        return axios.get(process.env.VUE_APP_API_URL + `/minfund/getIviCardFee?` + data, {headers: this.header()})
    },
    /*提交充值凭证*/
    addRechargeVoucher(data) {
        return axios.post(process.env.VUE_APP_API_URL + `/minfund/addRechargeVoucher`, data, {headers: this.header()})
    },
    /*存款*/
    addDeposit(data) {
        return axios.post(process.env.VUE_APP_API_URL + `/minfund/addDeposit`, data, {headers: this.header()})
    },
    /*汇率获取*/
    getRate(data) {
        return axios.get(process.env.VUE_APP_API_URL + `/minfund/getRate?` + data, {headers: this.header()})
    },
    /*充值记录*/
    getDepositProposalList(data) {
        return axios.get(process.env.VUE_APP_API_URL + `/minfund/getDepositProposalList?` + data, {headers: this.header()})
    },
    /*根据订单号查询存款记录详情*/
    getRechargeDetailsByPno(data) {
        return axios.get(process.env.VUE_APP_API_URL + `/minfund/getRechargeDetailsByPno?` + data, {headers: this.header()})
    },
};
